.app {
  display: grid;
  grid-template-columns: 35% 1fr;
}

.sideBar {
  height: 97vh;
  position: relative;
  overflow: hidden;
  border-right: 5px dotted #cfdeec;
  display: flex;
  flex-direction: column;
}

.title {
  padding: 32px;
  font-size: 3rem;
  margin: 0;
}

.dataOptions {
  margin: 0 32px;
}

.dataOptionsOptions {
  display: flex;
  column-gap: 8px;
}

.dataOption {
  text-align: center;
  background: #fff;
  border: 2px solid #000;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  padding: 0 16px;
  font-size: 1.1rem;
  display: flex;
  box-shadow: 6px 6px #000;
  transition: all 0.2s linear;
  cursor: pointer;
}

.dataOption:hover,
.enabled {
  background: hsl(195deg 67% 64%);
  box-shadow: 3px 3px #000;
  transform: translateY(3px);
}

.questions {
  margin: 0px 32px;
  flex-grow: 1;
  z-index: 2;
  margin-bottom: 45px;
  position: relative;
}

.questionLabel {
  font-size: 1.25rem;
  margin-bottom: 8px;
}

.question {
  height: 200px;
  background: #fff;
  border: 2px solid #000;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  display: flex;
  box-shadow: 6px 6px 0px 0px rgb(0 0 0);
  margin-bottom: 24px;
  padding: 0px 16px;
  text-align: center;
}

.answer {
  height: 50px;
  background: #fff;
  border: 1px solid #000;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  display: flex;
  box-shadow: 2px 2px #000;
  margin: 6px 12px;
}

.answersData {
  height: 80px;
  background: #fff;
  border: 2px solid #000;
  justify-content: space-evenly;
  align-items: center;
  font-size: 1.25rem;
  display: flex;
  position: absolute;
  bottom: 6px;
  left: 32px;
  right: 32px;
  box-shadow: 6px 6px #000;
  z-index: 2;
}

.mapContainer {
  background-color: #e8f4ff;
  padding: 32px;
  height: 97vh;
  position: relative;
}
